import React from "react";
import {downLoadFile} from "../../helpers/functions";
import {Button, List, FormGroup} from 'arag-ui-lib';
import {REMOVE} from "../../helpers/constants";
import { FORM_GROUP_VARIANTS } from "../../helpers/formGroupVariants";

const AttachmentsList = (props) => {
    const {
        attachments, 
        onAttachmentRemove, 
        onAttachmentRequest,
        listTestId,
        listItemTestId,
    } = props;

    return (
        <List
            id={'editQuestion-attachment-list'}
            listTestId={listTestId}
            items={
                attachments.map((attachment, index) => {
                    // guards onLabelClick below: without a source to download from, clicking the name
                    // would call downLoadFile(name, undefined), which throws or builds a corrupt link
                    const canDownload = Boolean(attachment.encodedFile || onAttachmentRequest);
                    const handleRemove = () => onAttachmentRemove(attachment, index);
                    const handleDownload = () => onAttachmentRequest
                        ? onAttachmentRequest(attachment)
                        : downLoadFile(attachment.name, attachment.encodedFile);

                    return {
                        id: attachment.id,
                        linkItemTestId: `${listItemTestId}-${index}`,
                        content: (
                            <div key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                {
                                    onAttachmentRemove
                                    ?
                                        <Button
                                            variant={REMOVE}
                                            onClick={handleRemove}
                                        />
                                    :
                                        null
                                }
                                <FormGroup
                                    labelSize={'col-sm-12'}
                                    inputSize={''}
                                    variant={FORM_GROUP_VARIANTS.PLAIN}
                                    label={attachment.name}
                                    inputProps={{
                                        id: `attachment-${index}`,
                                        name: `attachment-${index}`,
                                    }}
                                    onLabelClick={canDownload ? handleDownload : undefined}
                                />
                            </div>
                        )
                    };
                })
            }
        />
    )
};

export default AttachmentsList;